import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { ClockIcon } from "mds/icons";

export const ReadOnlyBreakoutDuration = ({
  value,
  className,
}: {
  value: number;
  className?: string;
}) => (
  <div
    className={twMerge(
      "flex min-h-8 items-center justify-between gap-4 text-sm font-medium text-black-tint-10",
      className,
    )}
  >
    <div className="flex items-center gap-2 whitespace-nowrap">
      <ClockIcon />
      {t("breakout_group_modal.breakout_duration")}
    </div>
    <span className="whitespace-nowrap">
      {value} {t("breakout_group_modal.min")}
    </span>
  </div>
);
